import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppThunk } from "../app/store";
import { PageState, Account } from "../api/Types";
import { getAccount } from "../api/SwyftApi";

interface AccountState {
  pageState: PageState;
  accountId?: string | null;
  account: Account | null;
  error: string | null;
}

const initialState: AccountState = {
  pageState: PageState.Loading,
  account: null,
  accountId: null,
  error: null
};

function startLoading(state: AccountState) {
  state.pageState = PageState.Loading;
}

function loadingFailed(state: AccountState, action: PayloadAction<string>) {
  state.pageState = PageState.Error;
  state.error = action.payload;
}

const account = createSlice({
  name: "account",
  initialState,
  reducers: {
    getAccountStart: startLoading,
    getAccountSuccess(state, { payload }: PayloadAction<Account>) {
      state.pageState = PageState.Ready;
      state.accountId = payload.id;
      state.account = payload;
      state.error = null;
    },
    getAccountFailure: loadingFailed
  }
});

export const { getAccountStart, getAccountSuccess, getAccountFailure } = account.actions;

export default account.reducer;

export const fetchAccount =
  (accountId: string): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(getAccountStart());
      const account = await getAccount(accountId);
      dispatch(getAccountSuccess(account));
    } catch (err: any) {
      dispatch(getAccountFailure(err.toString()));
    }
  };
